export const RECEPTION_EVENT_SOURCE_TYPES = {
  UNKNOWN: 0,
  PROXYCARD: 1,
  MOBILE_NFC: 2,
  MOBILE_QR: 3,
  MOBILE_MANUAL: 4,
};
